import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { FilterTag } from 'components/filtertags'
import { OrigemDadoEnumRecord } from 'components/origem-label-tag/OrigemRegistroInfo'
import { useMemoWithDeepCompare } from 'hooks/useMemoWithDeepCompare'
import { useServerTime } from 'hooks/useServerTime'
import { useLocalStorageState } from 'hooks/useStorage'
import { humanizeDateRange } from 'util/date/humanize-date'

import { convertAtividadeColetivaFilterFormModelToInput } from '../converter-atividadeColetiva'
import {
  AtividadeColetivaFilterFormModel,
  AtividadeColetivaFonteEnum,
  tipoAtividadeRecord,
} from '../model-atividadeColetiva'

export const useAtividadeColetivaFilter = (isReuniao: boolean) => {
  const { acesso, profissional } = useAcessoLotacaoOrEstagio()

  const equipes = acesso?.equipe ? [acesso.equipe] : []

  const filterStorageKey = `${acesso.id}/atividade-coletiva-${isReuniao ? 'reuniao' : 'saude'}-filter`
  const [filter, setFilter] = useLocalStorageState<AtividadeColetivaFilterFormModel>(filterStorageKey, {
    defaultValue: {
      isReuniao,
      fonteRegistros: AtividadeColetivaFonteEnum.PEC,
      equipes,
      pageParams: {
        page: 0,
        size: 10,
        sort: ['-dataAtividade'],
      },
    },
    modifier: (value) => ({
      ...value,
      periodo: value.periodo
        ? {
            startDate: value.periodo.startDate ? new Date(value.periodo.startDate) : undefined,
            endDate: value.periodo.endDate ? new Date(value.periodo.endDate) : undefined,
          }
        : undefined,
    }),
  })

  const convertedFilter = useMemoWithDeepCompare(
    () => convertAtividadeColetivaFilterFormModelToInput(filter, profissional.cns ?? profissional.cpf),
    [profissional, filter]
  )

  const { getServerTimeNow } = useServerTime()
  const tipoAtividadeFilterTag = convertedFilter.tiposAtividade?.map((tipo) => tipoAtividadeRecord[tipo]).join(', ')
  const periodoAtividadeFilterTag = humanizeDateRange(convertedFilter.periodo, getServerTimeNow())
  const equipeFilterTag = convertedFilter.equipesIne
    ? [...new Set(filter.equipes?.map((equipe) => equipe.nome))].join(', ')
    : undefined
  const origemFilterTag = convertedFilter.origens?.map((origem) => OrigemDadoEnumRecord[origem]?.nome).join(', ')
  const processadoFilterTag = convertedFilter.isProcessado && 'Sim'

  const filterTags: FilterTag[] = [
    ['Tipo de atividade', tipoAtividadeFilterTag],
    ['Período da atividade', periodoAtividadeFilterTag],
    ['Equipe', equipeFilterTag],
    ['Origem', origemFilterTag],
    ['Processado', processadoFilterTag],
  ]

  return { filter, setFilter, convertedFilter, filterTags }
}
